<template>
  <div id="signUp">
    <div class="title">大赛报名</div>
    <div class="form">
      <el-form
        label-position="left"
        label-width="70px"
        :model="formData"
        :rules="rules"
        ref="uploadForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input
            v-model="formData.name"
            placeholder="仅限中英文，10个字以内"
            class="input-item"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model.number="formData.phone"
            placeholder=""
            class="input-code"
          ></el-input>
          <el-button
            size="small"
            type="primary"
            class="button-inline codebtn"
            @click="sendCodeEvent"
            :disabled="baseData.sec > 0"
            >{{
              baseData.sec > 0 ? `${baseData.sec}秒后可重发` : "发送验证码"
            }}</el-button
          >
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input
            v-model="formData.code"
            placeholder=""
            class="input-code"
          ></el-input>
        </el-form-item>
        <el-form-item class="read-confirm">
          <el-checkbox v-model="formData.checked"></el-checkbox>
          <span class="protocol"
            >我已阅读<i @click="dialogVisible = true">《投稿须知》</i
            >，并同意所有条款</span
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="button-block"
            @click="formSubmitEvent"
            style="width: 400px"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="tougaoxuzhi">
      <el-dialog v-model="dialogVisible">
        <!-- <img style="width: 100%" src="../assets/img/tougaoxuzhi.jpg" alt="" /> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import {
  sendVerificationCode,
  registerByCode,
  info,
} from "../utils/apis/userLoginApi";

export default {
  name: "signUp",
  setup() {
    // var validateName = (rule, value, callback) => {
    //   let flag = true;
    //   if (/^\s+$/.test(value)) {
    //     flag = false;
    //   }

    //   if (!/^[\u4e00-\u9fa5a-zA-Z\s]{1,16}$/.test(value)) {
    //     flag = false;
    //   }

    //   let match = value.match(/[\u4e00-\u9fa5]/g);

    //   if (!(!match || (match && match.length < 5))) {
    //     flag = false;
    //   }

    //   match = value.match(/[A-Za-z\s]/g);
    //   if (!(!match || (match && match.length < 13))) {
    //     flag = false;
    //   }
    //   if (flag) {
    //     callback();
    //   } else {
    //     callback(new Error("限中文4个字以内，英文12个字母以内"));
    //   }
    // };
    const dialogVisible = ref(false);
    const router = useRouter();
    const route = useRoute();
    console.log(route.query.toMywork);
    const formData = reactive({
      name: "",
      code: "",
      phone: "",
      checked: false,
    });
    const rules = reactive({
      name: [
        { required: true, message: "请输入姓名", trigger: "blur" },
        {
          pattern: /^[\u4e00-\u9fa5a-zA-Z]{1,10}$/,
          message: "仅限中英文，10个字以内",
          trigger: "blur",
        },
      ],
      phone: [
        { required: true, message: "请输入正确的手机号", trigger: "blur" },
        {
          pattern: /^1[3456789]\d{9}$/,
          message: "请输入正确的手机号",
          trigger: "blur",
        },
      ],
      code: [
        { required: true, message: "请输入6位验证码", trigger: "blur" },
        {
          pattern: /^\d{6}$/,
          message: "请输入6位验证码",
          trigger: "blur",
        },
      ],
    });
    const uploadForm = ref(null);
    const baseData = reactive({
      sec: 0,
      showViewer: "",
    });
    let timer = ref(null);

    /**
     * 倒计时
     */
    function countdownFn() {
      clearInterval(timer);
      timer = setInterval(() => {
        if (baseData.sec <= 0) {
          clearInterval(timer);
        } else {
          baseData.sec--;
        }
      }, 1000);
    }

    //发送验证码
    function sendCodeEvent() {
      //   loginByCode();
      if (baseData.sec > 0) {
        return;
      }
      uploadForm.value.validateField("phone", (err) => {
        if (!err) {
          baseData.sec = 90;
          countdownFn();

          sendVerificationCode({ phone: formData.phone }).then((res) => {
            if (res.data.code == 200) {
              ElMessage({
                message: "验证码已发送",
                type: "success",
                customClass: "myElMessage",
              });
            } else {
              baseData.sec = 0;
              ElMessage({
                message: res.data.message,
                type: "error",
                customClass: "myElMessage",
              });
            }
          });
        }
      });
    }
    //注册
    function formSubmitEvent() {
      if (!formData.checked) {
        ElMessage({
          message: "请同意 《投稿须知》",
          type: "error",
          customClass: "myElMessage",
        });
        return;
      }
      uploadForm.value.validate((vaild) => {
        if (vaild) {
          let params = {
            name: formData.name,
            phone: formData.phone,
            code: formData.code,
          };
          registerByCode(params).then((res) => {
            if (res.data.code == 200) {
              ElMessage({
                message: "报名成功",
                type: "success",
                customClass: "myElMessage",
              });
              localStorage.setItem("token", JSON.stringify(res.data.data));
              info().then((res) => {
                console.log(res);
                if (res.data.code === 200) {
                  localStorage.setItem(
                    "userInfo",
                    JSON.stringify(res.data.data)
                  );
                  if (route.query.toMywork != undefined) {
                    setTimeout(() => {
                      router.push({ path: "/myWorks" });
                    }, 2000);
                  } else {
                    setTimeout(() => {
                      router.push({ path: "/upLoadFile" });
                    }, 2000);
                  }
                }
              });
            } else if (res.data.message === "该手机号已注册，请登录。") {
              ElMessage({
                message: res.data.message,
                type: "error",
                customClass: "myElMessage",
              });
              setTimeout(() => {
                router.push({ path: "/userLogin", query: { toUpload: true } });
              }, 2000);
            } else {
              ElMessage({
                message: res.data.message,
                type: "error",
                customClass: "myElMessage",
              });
            }
          });
        }
      });
    }
    return {
      router,
      formData,
      countdownFn,
      uploadForm,
      baseData,
      rules,
      formSubmitEvent,
      sendCodeEvent,
      dialogVisible,
    };
  },
};
</script>

<style lang="less" scoped>
#signUp {
  padding-top: 70px;
  max-width: 1600px;
  min-width: 1200px;
  margin: 0 auto;
  .title {
    font-size: 36px;
    font-weight: bold;
    color: #303133;
    text-align: center;
    margin-bottom: 55px;
  }
  .form {
    width: 470px;
    margin: 0 auto;
    padding-bottom: 200px;
    .el-form-item__label {
      font-size: 14px;
      color: #303133;
    }
  }
  .protocol {
    vertical-align: -1px;
    color: #909399;
    margin-left: 10px;
    i {
      font-style: normal;
      cursor: pointer;
      transition: 0.2s;
    }
    i:hover {
      color: #003588;
    }
  }
  .input-code {
    width: 180px;
    margin-right: 20px;
  }
  .codebtn {
    width: 150px;
    height: 40px;
    background-color: #003588;
    color: #ffffff;
  }
}
.tougaoxuzhi/deep/ .el-dialog {
  // height:5px;
  height: 744px;
  width: 790px !important;
  background-image: url("../assets/img/tougaoxuzhi.jpg");
  background-size: contain;
  background-repeat: no-repeat;
  // background-position:center;
}
</style>
